import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const strengths = [
  { key: "global", icon: "ri-global-line" },
  { key: "risk", icon: "ri-shield-check-line" },
  { key: "team", icon: "ri-team-line" },
];

export default function AboutPreview() {
  const { t } = useTranslation(["pages"]);

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="w-full h-[480px] rounded-xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/a65569f7276d370e867fae92f00d9efe.jpg"
                alt="Medigreen Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-6 -right-6 bg-emerald-700 text-white rounded-xl p-6 hidden lg:block">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-global-line text-emerald-300 text-xl" />
                </div>
                <span className="text-emerald-200 text-xs font-semibold uppercase tracking-widest">
                  {t("pages:home.about.badge.label")}
                </span>
              </div>
              <div
                className="text-3xl font-bold"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {t("pages:home.about.badge.value")}
              </div>
              <div className="text-emerald-200 text-sm mt-1">
                {t("pages:home.about.badge.sublabel")}
              </div>
              <div className="mt-3 flex gap-1">
                {["🇺🇸", "🇯🇵", "🇦🇪", "🇸🇬", "🇳🇱"].map((flag) => (
                  <span key={flag} className="text-lg">
                    {flag}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <p className="text-emerald-700 text-sm font-semibold uppercase tracking-widest mb-4">
              {t("pages:home.about.sectionTitle")}
            </p>
            <h2
              className="text-4xl font-bold leading-tight mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              <span className="italic text-emerald-700">
                {t("pages:home.about.title")}
              </span>
              <br />
              <span className="text-slate-900">
                {t("pages:home.about.titleHighlight")}
              </span>
            </h2>
            <p className="text-slate-600 leading-relaxed mb-6">
              {t("pages:home.about.description1")}
            </p>
            <p className="text-slate-600 leading-relaxed mb-8">
              {t("pages:home.about.description2")}
            </p>

            {/* Strengths */}
            <div className="space-y-5 mb-10">
              {strengths.map((s) => (
                <div key={s.key} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-emerald-100 text-emerald-700 flex-shrink-0">
                    <i className={`${s.icon} text-lg`} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-slate-900 text-sm mb-1">
                      {t(`pages:home.about.strengths.${s.key}.title`)}
                    </h4>
                    <p className="text-slate-500 text-sm leading-relaxed">
                      {t(`pages:home.about.strengths.${s.key}.desc`)}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-700 text-white font-semibold px-8 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              {t("pages:home.about.cta")}
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}